import type { FacebookPostType } from '@pulsify/shared/dto'
import { Facebook } from 'lucide-react'
import { useCurrentBusiness } from '~/entities/business/model/use-business'
import { useCreateFacebookPost } from '~/entities/crossposting/model/use-facebook-post'
import {
  type ComposerConfig,
  SocialPostComposer,
} from '~/features/crossposting/components/social-post-composer'
import * as m from '~/paraglide/messages'

const FACEBOOK_CONFIG: ComposerConfig = {
  platform: 'facebook',
  title: m.crosspostingFacebookTitle,
  description: m.crosspostingFacebookDescription,
  publishLabel: m.crosspostingPublishFacebook,
  publishedLabel: m.crosspostingPublished,
  icon: Facebook,
  types: [
    {
      value: 'post',
      label: m.crosspostingFbPagePost,
      hint: m.crosspostingFbPagePostHint,
      maxImages: 10,
      mediaRequired: true,
    },
    {
      value: 'reel',
      label: m.crosspostingFbReel,
      hint: m.crosspostingFbReelHint,
      disabled: true,
      maxImages: 0,
      mediaRequired: false,
    },
    {
      value: 'story',
      label: m.crosspostingFbStory,
      hint: m.crosspostingFbStoryHint,
      maxImages: 1,
      mediaRequired: true,
    },
  ],
}

export function FacebookPostTool({ listingId }: { listingId: string }) {
  const { data: business } = useCurrentBusiness()
  const createPost = useCreateFacebookPost(business?.id ?? '', listingId)

  return (
    <SocialPostComposer
      listingId={listingId}
      config={FACEBOOK_CONFIG}
      onPublish={async ({ type, text, link, files }) => {
        await createPost.mutateAsync({
          payload: {
            type: type as FacebookPostType,
            text: text.trim() || undefined,
            link: link.trim() || undefined,
          },
          files,
        })
      }}
    />
  )
}
